import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import duration from "dayjs/plugin/duration";
import localizedFormat from "dayjs/plugin/localizedFormat";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import advancedFormat from "dayjs/plugin/advancedFormat";
import React, { useState } from "react";
import useAppStore from "../stores/appStore";
import { selectedAssistantSelector } from "../stores/selectors/appSelectors";
import { DEFAULT_TIMEZONE, TIMEZONE_DISPLAY_NAMES } from "@consts";

// dayjs plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);

const DateTimeContext = React.createContext(null);

const DEFAULT_DATE_RANGE = dayjs.duration(1, "w");

const DateTimeProvider = ({ children }) => {
  const selectedAssistant = useAppStore(selectedAssistantSelector);
  const timezoneKey = selectedAssistant?.timezone || DEFAULT_TIMEZONE;
  const timeZone = TIMEZONE_DISPLAY_NAMES[timezoneKey]?.timezone;

  const getTimeZoneDate = (timeString, overrideTimezone) => dayjs.tz(dayjs(timeString), overrideTimezone || timeZone);

  const localDate = (timeString) => dayjs(timeString);

  const formattedTimezone = (timeString) => getTimeZoneDate(timeString).format("L LT");

  const formattedTimezoneSeconds = (timeString) =>
    getTimeZoneDate(timeString).format("hh:mm:ss A");

  const formattedTimezoneMilliSeconds = (timeString) =>
    getTimeZoneDate(timeString).format("hh:mm:ss.SSS A");

  const [fromDate, setFromDate] = useState(
    () => getTimeZoneDate().subtract(DEFAULT_DATE_RANGE).startOf("d").toDate()
  );
  const [toDate, setToDate] = useState(() => getTimeZoneDate().toDate());

  const ctxValue = {
    timeZone,
    getTimeZoneDate,
    localDate,
    formattedTimezone,
    formattedTimezoneSeconds,
    formattedTimezoneMilliSeconds,
    fromDate,
    toDate,
    setFromDate,
    setToDate
  };

  return (
    <DateTimeContext.Provider value={ctxValue}>
      {children}
    </DateTimeContext.Provider>
  );
};

export default DateTimeContext;

export { DateTimeProvider };
